<template>
    <div>
        <div class="vx-row">
            <div class="vx-col lg:w-1/2 w-full mb-6">
                <vx-card id="sourceData" class="vs-con-loading__container" :title="(channelMap[source.channel_id]) ? channelMap[source.channel_id].name : ''">
                    <vs-checkbox :disabled="editingDisabled" class="mt-3" v-model="editObject['checker_enabled']">Enable checker</vs-checkbox>
                    <vs-checkbox :disabled="editingDisabled" class="mt-3" v-model="editObject['audio_only']">Audio only</vs-checkbox>
                    <vs-checkbox :disabled="editingDisabled" class="mt-3" v-model="editObject['override_work_template']">Override work template</vs-checkbox>
                    <vs-checkbox :disabled="editingDisabled" class="mt-3" v-model="editObject['override_out_template']">Override output template</vs-checkbox>
                    <p class="mt-6">URL</p>
                    <vs-input :disabled="editingDisabled" v-model="editObject['url']" class="w-full"></vs-input>
                    <p class="mt-6">Provider</p>
                    <vs-select autocomplete :disabled="editingDisabled" class="w-full" v-model="editObject['provider_id']">
                        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in providers" />
                    </vs-select>
                    <p class="mt-6">Allowed location</p>
                    <vs-select autocomplete :disabled="editingDisabled" class="w-full" v-model="editObject['location_id']">
                        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in locations" />
                    </vs-select>
                    <p class="mt-6">Input template</p>
                    <vs-select autocomplete :disabled="editingDisabled" class="w-full" v-model="editObject['in_template'].id">
                        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in inputTemplates" />
                    </vs-select>
                    <div v-if="inputTemplateMap[editObject['in_template'].id] && inputTemplateMap[editObject['in_template'].id].params.length > 0">
                        <h6 class="mt-6">Input Template parameters</h6>
                        <div class="w-full vx-row mb-4" :key="item.key" v-for="item in inputTemplateMap[editObject['in_template'].id].params">
                            <div class="vx-col w-1/2">
                                <vs-checkbox :disabled="editingDisabled" class="mt-3" v-model="enabledInputTemplateParameters" :vs-value="item.key">{{item.name}}</vs-checkbox>
                            </div>
                            <div class="vx-col w-1/2">
                                <vs-input :disabled="editingDisabled" v-if="enabledInputTemplateParameters.includes(item.key)" v-model="inputTemplateParams[item.key]" class="w-full"></vs-input>
                                <vs-input v-else disabled v-model="item.default" class="w-full"></vs-input>
                            </div>

                        </div>
                    </div>
                    <div v-if="editObject['override_work_template']">
                        <vs-divider/>
                        <p class="mt-6">Work template</p>
                        <vs-select autocomplete :disabled="editingDisabled" class="w-full" v-model="editObject['work_template'].id">
                            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in workTemplates" />
                        </vs-select>
                        <div v-if="workTemplateMap[editObject['work_template'].id] && workTemplateMap[editObject['work_template'].id].params.length > 0">
                            <h6 class="mt-6">Work Template parameters</h6>
                            <div class="w-full vx-row mb-4" :key="item.key" v-for="item in workTemplateMap[editObject['work_template'].id].params">
                                <div class="vx-col w-1/2">
                                    <vs-checkbox :disabled="editingDisabled" class="mt-3" v-model="enabledWorkTemplateParameters" :vs-value="item.key">{{item.name}}</vs-checkbox>
                                </div>
                                <div class="vx-col w-1/2">
                                    <vs-input :disabled="editingDisabled" v-if="enabledWorkTemplateParameters.includes(item.key)" v-model="workTemplateParams[item.key]" class="w-full"></vs-input>
                                    <vs-input v-else disabled v-model="item.default" class="w-full"></vs-input>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div v-if="editObject['override_out_template']">
                        <vs-divider/>
                        <p class="mt-6">Output template</p>
                        <vs-select autocomplete :disabled="editingDisabled" class="w-full" v-model="editObject['out_template'].id">
                            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in outputTemplates" />
                        </vs-select>
                        <div v-if="outputTemplateMap[editObject['out_template'].id] && outputTemplateMap[editObject['out_template'].id].params.length > 0">
                            <h6 class="mt-6">Output Template parameters</h6>
                            <div class="w-full vx-row mb-4" :key="item.key" v-for="item in outputTemplateMap[editObject['out_template'].id].params">
                                <div class="vx-col w-1/2">
                                    <vs-checkbox :disabled="editingDisabled" class="mt-3" v-model="enabledOutputTemplateParameters" :vs-value="item.key">{{item.name}}</vs-checkbox>
                                </div>
                                <div class="vx-col w-1/2">
                                    <vs-input :disabled="editingDisabled" v-if="enabledOutputTemplateParameters.includes(item.key)" v-model="outputTemplateParams[item.key]" class="w-full"></vs-input>
                                    <vs-input v-else disabled v-model="item.default" class="w-full"></vs-input>
                                </div>

                            </div>
                        </div>
                    </div>

                    <vs-divider/>

                    <vs-button icon-pack="feather" icon="icon-lock" v-if="editingDisabled" color="warning" class="mt-6; mr-1" @click="editingDisabled = false">Edit</vs-button>
                    <vs-button style="float: left" icon-pack="feather" icon="icon-lock" v-if="!editingDisabled" color="warning" class="mt-6; mr-1" @click="disableEditing">Stop editing</vs-button>
                    <vs-button style="float: left" icon-pack="feather" icon="icon-save" v-if="!editingDisabled" color="success" class="mt-6; mr-1" @click="saveSource">Save</vs-button>
                    <vs-button style="float: right" icon-pack="feather" icon="icon-trash-2" v-if="!editingDisabled" color="danger" class="mt-6; mr-1" @click="removeSource"/>
                    <div style="clear: both"></div>

                </vx-card>
            </div>

            <div class="vx-col lg:w-1/2 w-full mb-6">
                <vx-card title="Uptime" id="uptimeCard" class="vs-con-loading__container">

                    <template slot="actions">
                        <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                            <small class="flex cursor-pointer">
                                <span>{{metricTimes[uptimeRange]}}</span>
                                <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                            </small>
                            <vs-dropdown-menu class="w-48">
                                <vs-dropdown-item @click="uptimeRange = 1">Last hour</vs-dropdown-item>
                                <vs-dropdown-item @click="uptimeRange = 6">Last 6 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="uptimeRange = 12">Last 12 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="uptimeRange = 24">Last 24 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="uptimeRange = 167">Last 7 days</vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>

                        <feather-icon icon="RefreshCwIcon" @click="loadUptimeData()"></feather-icon>
                    </template>

                    <vue-apex-charts v-if="uptimeChartOptions" type="line" height="350" :options="uptimeChartOptions" :series="uptimeData"/>

                </vx-card>
            </div>

            <div class="vx-col lg:w-1/2 w-full mb-6">
                <vx-card title="Score" id="scoreCard" class="vs-con-loading__container">

                    <template slot="actions">
                        <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                            <small class="flex cursor-pointer">
                                <span>{{metricTimes[scoreRange]}}</span>
                                <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                            </small>
                            <vs-dropdown-menu class="w-48">
                                <vs-dropdown-item @click="scoreRange = 1">Last hour</vs-dropdown-item>
                                <vs-dropdown-item @click="scoreRange = 6">Last 6 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="scoreRange = 12">Last 12 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="scoreRange = 24">Last 24 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="scoreRange = 167">Last 7 days</vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>

                        <feather-icon icon="RefreshCwIcon" @click="loadScoreData()"></feather-icon>
                    </template>

                    <vue-apex-charts v-if="scoreChartOptions" type="line" height="350" :options="scoreChartOptions" :series="scoreData"/>

                </vx-card>
            </div>

            <div class="vx-col lg:w-1/2 w-full mb-6">
                <vx-card title="Stream difference" id="streamDiffCard" class="vs-con-loading__container">

                    <template slot="actions">
                        <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                            <small class="flex cursor-pointer">
                                <span>{{metricTimes[streamDiffRange]}}</span>
                                <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                            </small>
                            <vs-dropdown-menu class="w-48">
                                <vs-dropdown-item @click="streamDiffRange = 1">Last hour</vs-dropdown-item>
                                <vs-dropdown-item @click="streamDiffRange = 6">Last 6 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="streamDiffRange = 12">Last 12 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="streamDiffRange = 24">Last 24 hours</vs-dropdown-item>
                                <vs-dropdown-item @click="streamDiffRange = 167">Last 7 days</vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>

                        <feather-icon icon="RefreshCwIcon" @click="loadStreamDiffData()"></feather-icon>
                    </template>

                    <vue-apex-charts v-if="streamDiffChartOptions" type="line" height="350" :options="streamDiffChartOptions" :series="streamDiffData"/>

                </vx-card>
            </div>

        </div>

        <div class="vx-row">
            <div v-if="video_streams.length > 0" class="vx-col w-full mt-6">
                <vx-card title="Video streams">

                    <vs-table :data="video_streams">

                        <template slot="thead">
                            <vs-th sort-key="index">Stream index</vs-th>
                            <vs-th sort-key="id">ID</vs-th>
                            <vs-th sort-key="codec_name">Codec name</vs-th>
                            <vs-th sort-key="width">Width</vs-th>
                            <vs-th sort-key="height">Height</vs-th>
                            <vs-th sort-key="display_aspect_ratio">Aspect ratio</vs-th>
                            <vs-th sort-key="avg_frame_rate">AVG Frame Rate</vs-th>
                            <vs-th sort-key="start_time">Start time</vs-th>
                            <vs-th sort-key="tags">Tags</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <tbody>
                                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                                    <vs-td :data="data[index].index">
                                        {{ data[index].index }}
                                    </vs-td>

                                    <vs-td :data="data[index].id">
                                        {{ data[index].id }}
                                    </vs-td>

                                    <vs-td :data="data[index].codec_name">
                                        {{ data[index].codec_name }}
                                    </vs-td>

                                    <vs-td :data="data[index].width">
                                        {{ data[index].width }}
                                    </vs-td>

                                    <vs-td :data="data[index].height">
                                        {{ data[index].height }}
                                    </vs-td>

                                    <vs-td :data="data[index].display_aspect_ratio">
                                        {{ data[index].display_aspect_ratio }}
                                    </vs-td>

                                    <vs-td :data="data[index].avg_frame_rate">
                                        {{ data[index].avg_frame_rate }}
                                    </vs-td>

                                    <vs-td :data="data[index].start_time_parsed">
                                        {{ data[index].start_time_parsed }}
                                    </vs-td>

                                    <vs-td :data="data[index].tags">
                                        {{ data[index].tags }}
                                    </vs-td>

                                </vs-tr>
                            </tbody>
                        </template>

                    </vs-table>
                </vx-card>
            </div>

            <div v-if="audio_streams.length > 0" class="vx-col w-full mt-6">
                <vx-card title="Audio streams">

                    <vs-table :data="audio_streams">

                        <template slot="thead">
                            <vs-th sort-key="index">Stream index</vs-th>
                            <vs-th sort-key="id">ID</vs-th>
                            <vs-th sort-key="codec_name">Codec name</vs-th>
                            <vs-th sort-key="sample_rate_parsed">Sample rate</vs-th>
                            <vs-th sort-key="channels">Channels</vs-th>
                            <vs-th sort-key="channel_layout">Channel layout</vs-th>
                            <vs-th sort-key="start_time">Start time</vs-th>
                            <vs-th sort-key="tags">Tags</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <tbody>
                                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                                    <vs-td :data="data[index].index">
                                        {{ data[index].index }}
                                    </vs-td>

                                    <vs-td :data="data[index].id">
                                        {{ data[index].id }}
                                    </vs-td>

                                    <vs-td :data="data[index].codec_name">
                                        {{ data[index].codec_name }}
                                    </vs-td>

                                    <vs-td :data="data[index].sample_rate_parsed">
                                        {{ data[index].sample_rate_parsed }}
                                    </vs-td>

                                    <vs-td :data="data[index].channels">
                                        {{ data[index].channels }}
                                    </vs-td>

                                    <vs-td :data="data[index].channel_layout">
                                        {{ data[index].channel_layout }}
                                    </vs-td>

                                    <vs-td :data="data[index].start_time_parsed">
                                        {{ data[index].start_time_parsed }}
                                    </vs-td>

                                    <vs-td :data="data[index].tags">
                                        {{ data[index].tags }}
                                    </vs-td>

                                </vs-tr>
                            </tbody>
                        </template>

                    </vs-table>
                </vx-card>
            </div>

            <div v-if="subtitle_streams.length > 0" class="vx-col w-full mt-6">
                <vx-card title="Subtitle streams">

                    <vs-table :data="subtitle_streams">

                        <template slot="thead">
                            <vs-th sort-key="index">Stream index</vs-th>
                            <vs-th sort-key="id">ID</vs-th>
                            <vs-th sort-key="codec_name">Codec name</vs-th>
                            <vs-th sort-key="start_time">Start time</vs-th>
                            <vs-th sort-key="tags">Tags</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <tbody>
                                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                                    <vs-td :data="data[index].index">
                                        {{ data[index].index }}
                                    </vs-td>

                                    <vs-td :data="data[index].id">
                                        {{ data[index].id }}
                                    </vs-td>

                                    <vs-td :data="data[index].codec_name">
                                        {{ data[index].codec_name }}
                                    </vs-td>

                                    <vs-td :data="data[index].start_time_parsed">
                                        {{ data[index].start_time_parsed }}
                                    </vs-td>

                                    <vs-td :data="data[index].tags">
                                        {{ data[index].tags }}
                                    </vs-td>

                                </vs-tr>
                            </tbody>
                        </template>

                    </vs-table>
                </vx-card>
            </div>

            <div v-if="data_streams.length > 0" class="vx-col w-full mt-6">
                <vx-card title="Data streams">

                    <vs-table :data="data_streams">

                        <template slot="thead">
                            <vs-th sort-key="index">Stream index</vs-th>
                            <vs-th sort-key="id">ID</vs-th>
                            <vs-th sort-key="codec_name">Codec name</vs-th>
                            <vs-th sort-key="tags">Tags</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <tbody>
                                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                                    <vs-td :data="data[index].index">
                                        {{ data[index].index }}
                                    </vs-td>

                                    <vs-td :data="data[index].id">
                                        {{ data[index].id }}
                                    </vs-td>

                                    <vs-td :data="data[index].codec_name">
                                        {{ data[index].codec_name }}
                                    </vs-td>

                                    <vs-td :data="data[index].tags">
                                        {{ data[index].tags }}
                                    </vs-td>

                                </vs-tr>
                            </tbody>
                        </template>

                    </vs-table>
                </vx-card>
            </div>
        </div>
    </div>
</template>
<script>

    import VueApexCharts from 'vue-apexcharts'

    export default {
        components: {
            VueApexCharts
        },
        data() {
            return {

                source: {
                    channel_id: '',
                    provider_id: '',
                    url: '',
                    in_template: {},
                    work_template: {},
                    out_template: {},
                    checker_enabled: false,
                    audio_only: false
                },

                editObject: {
                    channel_id: '',
                    provider_id: '',
                    url: '',
                    in_template: {},
                    work_template: {},
                    out_template: {},
                    checker_enabled: false,
                    audio_only: false
                },

                inputTemplates: [],
                workTemplates: [],
                outputTemplates: [],
                providers: [],
                channels: [],

                locations: [],

                enabledInputTemplateParameters: [],
                inputTemplateParams: {},

                enabledWorkTemplateParameters: [],
                workTemplateParams: {},

                enabledOutputTemplateParameters: [],
                outputTemplateParams: {},

                dataLoaded: false,

                editingDisabled: true,

                video_streams: [],
                audio_streams: [],
                subtitle_streams: [],
                data_streams: [],
                stream_format: {},

                uptimeData: [],
                scoreData: [],
                streamDiffData: [],

                uptimeRange: 6,
                scoreRange: 6,
                streamDiffRange: 6,

                metricTimes: {
                    1: 'Last hour',
                    6: 'Last 6 hours',
                    12: 'Last 12 hours',
                    24: 'Last 24 hours',
                    167: 'Last 7 days'

                },

                uptimeChartOptions: null,
                scoreChartOptions: null,
                streamDiffChartOptions: null
            }
        },
        methods: {
            disableEditing() {
                this.editingDisabled = true
                this.loadData()
            },
            loadData() {
                this.editingDisabled = true

                this.$vs.loading({
                    container: '#sourceData',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/source/' + this.$route.params.id)
                loadPromise.then(function(response) {
                    thisIns.source = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const streamsPromise = this.$http.get('/api/management/v1/source/' + this.$route.params.id + '/streams')
                streamsPromise.then(function(response) {
                    thisIns.video_streams = response.data.video_streams
                    thisIns.audio_streams = response.data.audio_streams
                    thisIns.subtitle_streams = response.data.subtitle_streams
                    thisIns.data_streams = response.data.data_streams
                    thisIns.stream_format = response.data.format
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const locationsPromise = this.$http.get('/api/management/v1/location/')
                locationsPromise.then(function(response) {
                    thisIns.locations = [{ id: 0, name: 'Any' }].concat(response.data)
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const inputTemplatePromise = this.$http.get('/api/management/v1/template/?type=0')
                inputTemplatePromise.then(function(response) {
                    thisIns.inputTemplates = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const workTemplatePromise = this.$http.get('/api/management/v1/template/?type=1')
                workTemplatePromise.then(function(response) {
                    thisIns.workTemplates = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const outputTemplatePromise = this.$http.get('/api/management/v1/template/?type=2')
                outputTemplatePromise.then(function(response) {
                    thisIns.outputTemplates = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const providersPromise = this.$http.get('/api/management/v1/provider/')
                providersPromise.then(function(response) {
                    thisIns.providers = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const channelsPromise = this.$http.get('/api/management/v1/channel/')
                channelsPromise.then(function(response) {
                    thisIns.channels = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                Promise.all([loadPromise, inputTemplatePromise, workTemplatePromise, outputTemplatePromise, providersPromise, channelsPromise, locationsPromise]).then(function() {
                    thisIns.editObject = JSON.parse(JSON.stringify(thisIns.source))

                    thisIns.$nextTick(function() {
                        for (let x = 0; x < thisIns.source.in_template.params.length; x++) {
                            thisIns.enabledInputTemplateParameters.push(thisIns.source.in_template.params[x].key)
                            thisIns.inputTemplateParams[thisIns.source.in_template.params[x].key] = thisIns.source.in_template.params[x].value
                        }

                        for (let x = 0; x < thisIns.source.work_template.params.length; x++) {
                            thisIns.enabledWorkTemplateParameters.push(thisIns.source.work_template.params[x].key)
                            thisIns.workTemplateParams[thisIns.source.work_template.params[x].key] = thisIns.source.work_template.params[x].value
                        }

                        for (let x = 0; x < thisIns.source.out_template.params.length; x++) {
                            thisIns.enabledOutputTemplateParameters.push(thisIns.source.out_template.params[x].key)
                            thisIns.outputTemplateParams[thisIns.source.out_template.params[x].key] = thisIns.source.out_template.params[x].value
                        }
                    })
                }).finally(function() {
                    thisIns.$vs.loading.close('#sourceData > .con-vs-loading')
                    thisIns.dataLoaded = true
                })
            },
            saveSource() {
                this.$vs.loading({
                    container: '#sourceData',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const inputTemplateParams = []
                for (let i = 0; i < this.enabledInputTemplateParameters.length; i++) {
                    if (this.inputTemplateParams.hasOwnProperty(this.enabledInputTemplateParameters[i])) {
                        inputTemplateParams.push({
                            key: this.enabledInputTemplateParameters[i],
                            value: this.inputTemplateParams[this.enabledInputTemplateParameters[i]]
                        })
                    }
                }

                const workTemplateParams = []
                for (let i = 0; i < this.enabledWorkTemplateParameters.length; i++) {
                    if (this.workTemplateParams.hasOwnProperty(this.enabledWorkTemplateParameters[i])) {
                        workTemplateParams.push({
                            key: this.enabledWorkTemplateParameters[i],
                            value: this.workTemplateParams[this.enabledWorkTemplateParameters[i]]
                        })
                    }
                }

                const outputTemplateParams = []
                for (let i = 0; i < this.enabledOutputTemplateParameters.length; i++) {
                    if (this.outputTemplateParams.hasOwnProperty(this.enabledOutputTemplateParameters[i])) {
                        outputTemplateParams.push({
                            key: this.enabledOutputTemplateParameters[i],
                            value: this.outputTemplateParams[this.enabledOutputTemplateParameters[i]]
                        })
                    }
                }

                const addPromise = this.$http.put('/api/management/v1/source/' + this.$route.params.id, {
                    provider_id: Number(this.editObject.provider_id),
                    location_id: Number(this.editObject.location_id),
                    in_template: {
                        id: Number(this.editObject.in_template.id),
                        params: inputTemplateParams
                    },
                    work_template: {
                        id: Number(this.editObject.work_template.id),
                        params: workTemplateParams
                    },
                    out_template: {
                        id: Number(this.editObject.out_template.id),
                        params: outputTemplateParams
                    },
                    override_work_template: this.editObject.override_work_template,
                    override_out_template: this.editObject.override_out_template,
                    url: this.editObject.url,
                    checker_enabled: this.editObject.checker_enabled,
                    audio_only: this.editObject.audio_only
                })

                addPromise.then(function() {
                    thisIns.loadData()
                    thisIns.$printSuccess('Source saved')
                    thisIns.$vs.loading.close('#sourceData > .con-vs-loading')
                })

                addPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#sourceData > .con-vs-loading')
                })
            },
            removeSource() {
                this.$vs.loading({
                    container: '#sourceData',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const removePromise = this.$http.delete('/api/management/v1/source/' + this.$route.params.id)
                removePromise.then(function() {
                    thisIns.$printSuccess('Source removed')
                    thisIns.$vs.loading.close('#sourceData > .con-vs-loading')
                    thisIns.$nextTick(() => {
                        thisIns.$router.push('/sources/')
                    })
                })

                removePromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#sourceData > .con-vs-loading')
                })
            },
            loadUptimeData() {
                this.loadDataToObject('uptime', this.uptimeRange, 'uptimeData', '#uptimeCard', 'Uptime')
            },
            loadScoreData() {
                this.loadDataToObject('score', this.scoreRange, 'scoreData', '#scoreCard', 'Score')
            },
            loadStreamDiffData() {
                this.loadDataToObject('stream_diff', this.streamDiffRange, 'streamDiffData', '#streamDiffCard', 'Stream difference')
            },
            loadDataToObject(metric, time, objectName, loaderElement, name) {
                this.$vs.loading({
                    container: loaderElement,
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/source/' + this.$route.params.id + '/metrics/' + metric + '/' + time)
                loadPromise.then(function(response) {
                    thisIns[objectName] = [{ name: name, data: JSON.parse(JSON.stringify(response.data)) }]
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                loadPromise.finally(function() {
                    thisIns.$vs.loading.close(loaderElement + ' > .con-vs-loading')
                })
            },
            getMetricsChartOptions(title, colors) {
                return {
                    colors: colors,
                    xaxis: {
                        type: 'datetime',
                        tickAmount: 6,
                        labels: {
                            datetimeUTC: false
                        }
                    },
                    yaxis: {
                        tickAmount: 5,
                        min: 0
                    },
                    tooltip: {
                        x: {
                            format: 'dd/MM/yyyy HH:mm:ss'
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'straight'
                    },
                    title: {
                        text: title,
                        align: 'left'
                    }
                }
            }
        },
        computed: {
            inputTemplateMap() {
                const templatesMap = {}
                for (let i = 0; i < this.inputTemplates.length; i++) {
                    templatesMap[this.inputTemplates[i].id] = this.inputTemplates[i]
                }

                return templatesMap
            },
            workTemplateMap() {
                const templatesMap = {}
                for (let i = 0; i < this.workTemplates.length; i++) {
                    templatesMap[this.workTemplates[i].id] = this.workTemplates[i]
                }

                return templatesMap
            },
            outputTemplateMap() {
                const templatesMap = {}
                for (let i = 0; i < this.outputTemplates.length; i++) {
                    templatesMap[this.outputTemplates[i].id] = this.outputTemplates[i]
                }

                return templatesMap
            },
            channelMap() {
                const channelMap = {}
                for (let i = 0; i < this.channels.length; i++) {
                    channelMap[this.channels[i].id] = this.channels[i]
                }

                return channelMap
            }
        },
        watch: {
            'editObject.in_template.id'() {
                if (!this.inputTemplateMap[this.editObject.in_template.id]) return
                this.enabledInputTemplateParameters = []
                for (let i = 0; i < this.inputTemplateMap[this.editObject.in_template.id].params.length; i++) {
                    this.$set(this.inputTemplateParams, this.inputTemplateMap[this.editObject.in_template.id].params[i].key, this.inputTemplateMap[this.editObject.in_template.id].params[i].default)
                }
            },
            'editObject.work_template.id'() {
                if (!this.workTemplateMap[this.editObject.work_template.id]) return
                this.enabledWorkTemplateParameters = []
                for (let i = 0; i < this.workTemplateMap[this.editObject.work_template.id].params.length; i++) {
                    this.$set(this.workTemplateParams, this.workTemplateMap[this.editObject.work_template.id].params[i].key, this.workTemplateMap[this.editObject.work_template.id].params[i].default)
                }
            },
            'editObject.out_template.id'() {
                if (!this.outputTemplateMap[this.editObject.out_template.id]) return
                this.enabledOutputTemplateParameters = []
                for (let i = 0; i < this.outputTemplateMap[this.editObject.out_template.id].params.length; i++) {
                    this.$set(this.outputTemplateParams, this.outputTemplateMap[this.editObject.out_template.id].params[i].key, this.outputTemplateMap[this.editObject.out_template.id].params[i].default)
                }
            },
            uptimeRange() {
                this.loadUptimeData()
            },
            scoreRange() {
                this.loadScoreData()
            },
            streamDiffRange() {
                this.loadStreamDiffData()
            }
        },
        mounted() {
            this.loadData()

            this.uptimeChartOptions = this.getMetricsChartOptions('Uptime', ['#7367F0'])
            this.scoreChartOptions = this.getMetricsChartOptions('Score', ['#28C76F'])
            this.streamDiffChartOptions = this.getMetricsChartOptions('Stream difference', ['#EA5455'])

            this.loadUptimeData()
            this.loadScoreData()
            this.loadStreamDiffData()
        }
    }

</script>
